const translations = {
  "en": {
    "Change": "Change",
    "Fundamental": "Fundamental",
    "Market Cap": "Market Cap",
    "Momentum": "Momentum",
    "Rating": "Rating",
    "Token": "Token",
    "Tokenomics": "Tokenomics"
  },
  "zh-tw": {
    "Change": "漲跌",
    "Fundamental": "基本面",
    "Market Cap": "市值",
    "Momentum": "動能",
    "Rating": "評分",
    "Token": "代幣",
    "Tokenomics": "代幣經濟"
  }
};

export default translations;
